import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useStateStore = defineStore('state', {
  state: () => ({
    states: [],
    loading: false,
    error: null
  }),

  getters: {
    getStates: (state) => state.states,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  actions: {
    async fetchStates() {
      this.loading = true
      this.error = null
      
      try {
        const response = await api.get('/states')
        this.states = response.data
      } catch (error) {
        this.error = error.message || 'Failed to fetch states'
        // Fallback to static states if API fails
        this.states = [
          { id: 1, name: 'Andhra Pradesh' },
          { id: 2, name: 'Arunachal Pradesh' },
          { id: 3, name: 'Assam' },
          { id: 4, name: 'Bihar' },
          { id: 5, name: 'Chhattisgarh' },
          { id: 6, name: 'Goa' },
          { id: 7, name: 'Gujarat' },
          { id: 8, name: 'Haryana' },
          { id: 9, name: 'Himachal Pradesh' },
          { id: 10, name: 'Jharkhand' },
          { id: 11, name: 'Karnataka' },
          { id: 12, name: 'Kerala' },
          { id: 13, name: 'Madhya Pradesh' },
          { id: 14, name: 'Maharashtra' },
          { id: 15, name: 'Manipur' },
          { id: 16, name: 'Meghalaya' },
          { id: 17, name: 'Mizoram' },
          { id: 18, name: 'Nagaland' },
          { id: 19, name: 'Odisha' },
          { id: 20, name: 'Punjab' },
          { id: 21, name: 'Rajasthan' },
          { id: 22, name: 'Sikkim' },
          { id: 23, name: 'Tamil Nadu' },
          { id: 24, name: 'Telangana' },
          { id: 25, name: 'Tripura' },
          { id: 26, name: 'Uttar Pradesh' },
          { id: 27, name: 'Uttarakhand' },
          { id: 28, name: 'West Bengal' }
        ]
      } finally {
        this.loading = false
      }
    }
  }
}) 